import { useState, useEffect } from "react";
import {
  AES_KEY,
  USER_ID,
  USER_NAME,
  USER_EMP_ID,
  USER_MOBILE_NUMBER,
  USER_ROLE,
  ACCESS_TOKEN,
} from "../constants/constant";
import { getStorageValue } from "../utils/localStorage";
import { decryptStatic } from "../utils/decodeEncodeData";
import { roles } from '../constants/constant';

export function useUserDetail() {
  const [userData, setUserData] = useState(null);
  
  useEffect(() => {
    const userId = getStorageValue(USER_ID);
    const userName = getStorageValue(USER_NAME);
    const userEmpId = getStorageValue(USER_EMP_ID);
    const userMobileNumber = getStorageValue(USER_MOBILE_NUMBER);
    const aesKey = getStorageValue(AES_KEY);
    const userRole = getStorageValue(USER_ROLE);
    const accessToken = getStorageValue(ACCESS_TOKEN);

    if (aesKey && accessToken) {
      setUserData({
        userName: decryptStatic(userName, aesKey),
        userId: userId,
        userEmpId: userEmpId,
        userMobileNumber: decryptStatic(userMobileNumber, aesKey),
        isAdmin: userRole === roles.admin,
        role: userRole
      });
    };
  }, []);
  
  return userData;
};